/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type MovableAssetItemMovableSubType = (typeof MovableAssetItemMovableSubType)[keyof typeof MovableAssetItemMovableSubType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MovableAssetItemMovableSubType = {
  vehicle: "vehicle",
  company: "company",
  other: "other",
} as const;
